import React from 'react';
import classNames from 'classnames';
import { animated, SpringValues, PickAnimated } from 'react-spring';

import './Icon.less';

type IIconProps = Omit<React.HTMLProps<HTMLElement>, 'size' | 'ref' | 'crossOrigin'> & {
  size?: IconSize;
  inline?: boolean;
  animationStyle?: SpringValues<PickAnimated<any>>;
  className?: string;
  /**
   * Image url, icon will be rendered with img tag if provided.
   */
  src?: string;
};

export type IconSize = 'normal' | 'small' | 'input' | 'large' | 'native';

const getClassName = (className?: string, size?: IconSize, inline?: boolean) =>
  classNames('dpc-icon', className, {
    'dpc-icon--small': size === 'small',
    'dpc-icon--input': size === 'input',
    'dpc-icon--large': size === 'large',
    'dpc-icon--native': size === 'native',
    'dp-icon--inline': inline,
  });

/**
 * Component to render an icon by css class name, at standardized sizes.
 * For button use "IconButton" component.
 *
 * Copyright (c) 2019 Decisions ALl Rights Reserved
 */
export const Icon = ({ className, inline, size, animationStyle, src, ...otherProps }: IIconProps) => {
  // TODO talk to sasha about _why_ they needed a ref for this element... because
  // react-spring needs to be able to add a ref
  // might be able to accommodate both if we added the animation _here_ instead of from the outside.
  const Component = !!src ? animated.img : animated.i;

  return (
    <Component
      aria-label="icon"
      className={getClassName(className, size, inline)}
      src={src}
      {...otherProps}
      style={animationStyle}
    />
  );
};
